import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useControls } from "react-zoom-pan-pinch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";

function ZoomIn() {
  const { zoomIn, zoomOut, centerView } = useControls();
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Tooltip title="Zoom In">
      <IconButton
        aria-label="Zoom In"
        color="primary"
        onClick={(e) => {
          zoomIn(0.2, 100, "easeOut");
          e.currentTarget.blur();
        }}
        sx={{ marginRight: isMobile ? 0 : 2 }}
      >
        <ZoomInIcon fontSize="medium" />
      </IconButton>
    </Tooltip>
  );
}

export default ZoomIn;
